import React from 'react'
import { BrowserRouter, Route } from 'react-router-dom'
import Landing from './Landing'
import LandingAdmin from './LandingAdmin'
import LandingResellers from './LandingResellers'
import TwoFAPage from './TwoFAPage'
import HomeAdmin from './admin/Home'
import HomeResellers from './resellers/Home'
import PaymentSuccess from './consumers/PaymentSuccess'
import './main.css'

const originalConsoleError = console.error
console.error = (...args) => {
    if (typeof args[0] === 'string' && (args[0].includes('defaultProps') || args[0].includes('findDOMNode') || args[0].includes('children') || args[0].includes('non-boolean'))) return
    originalConsoleError(...args)
}

const App = () => {
    return <div className="container">
            <BrowserRouter>
                <div>
                    <Route exact path="/consumers" component={Landing} />
                    <Route exact path="/admin" component={LandingAdmin} />
                    <Route exact path="/resellers" component={LandingResellers} />
                    <Route exact path="/2fa" component={TwoFAPage} />
                    <Route exact path="/admin/home" component={(props) => <HomeAdmin {...props} isMobile={window.innerWidth <= 760} />}/>
                    <Route exact path="/resellers/home" component={(props) => <HomeResellers {...props} isMobile={window.innerWidth <= 760} />}/>
                    <Route exact path="/payment/success" component={PaymentSuccess} />
                </div>
            </BrowserRouter>
        </div>
}

export default App